import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export function articleImportUsername(utente) {
  const username = typeof utente?.username === "string" ? utente.username.trim() : "";
  if (!username || username.length > 50 || /^[A-Za-z0-9._-]+\|/.test(username)) {
    throw new Error("Username Domino mancante: aggiorna il profilo prima di importare.");
  }
  return username;
}

export default function useArticleImportRequest(utente) {
  const { getAccessTokenSilently } = useAuth0();
  return useCallback(async (url, formData) => {
    const username = articleImportUsername(utente);
    const token = await getAccessTokenSilently();
    formData.set("username", username);
    const response = await fetch(url, {
      method: "POST", body: formData,
      headers: { Authorization: `Bearer ${token}`, "X-Domino-Username": username },
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.error || error.message || "Importazione fallita.");
    }
    return response;
  }, [utente, getAccessTokenSilently]);
}
